import Vue from 'vue'
import Router from 'vue-router'
import JournalUploadForm from "./views/JournalUploadForm";
import Search from "./views/Search";
import Media from "./views/Media";
import Login from "./views/Login";
import Clipping from "./views/Clipping";
import {TokenService} from "./services/token.services";
import {UserService} from "./services/user.services";
import JournalDetails from "./views/JournalDetails";
import Organizations from "./views/Organizations";
import Users from "./views/Users";
import DashboardManager from "./views/DashboardManager";
import Reports from "./views/Reports";
import Clips from "./views/Clips";

import ROLES from "./constants/roles";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'search',
            component: Search,
            meta: {
                title: 'Instant Search',
                icon: 'search',
                layout: 'main',
                admin: false,
                showInNav: true,
                showDatePicker: true,
                roles: [ 
                    ROLES.SUPERADMIN, 
                    ROLES.ORGANIZATION_ADMIN, 
                    ROLES.ORGANIZATION_USER, 
                    ROLES.SCANNING_ADMIN, 
                    ROLES.BINDEZ_ADMIN 
                ]
            }
        },
        {
            path: '/journal',
            name: 'journal',
            component: JournalUploadForm,
            meta: {
                title: 'Publications',
                icon: 'import_contacts',
                layout: 'main',
                admin: true,
                showInNav: true,
                roles: [ 
                    ROLES.SUPERADMIN,
                    ROLES.SCANNING_ADMIN,
                ]
            }
        },
        {
            path: '/media',
            name: 'media',
            component: Media,
            meta: {
                title: 'Publishers',
                icon: 'public',
                layout: 'main',
                admin: true,
                showInNav: true,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.SCANNING_ADMIN
                ]
            }
        },
        {
            path: '/organization',
            name: 'organization',
            component: Organizations,
            meta: {
                title: 'Organizations',
                icon: 'group',
                layout: 'main',
                admin: true,
                showInNav: true,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.BINDEZ_ADMIN
                ]
            }
        },
        {
            path: '/user',
            name: 'user',
            component: Users,
            meta: {
                title: 'Users',
                icon: 'person',
                layout: 'main',
                showInNav: true,
                organizationAdmin: true,
                roles: [
                    ROLES.ORGANIZATION_ADMIN
                ]
            }
        },
        {
            path: '/admin/user',
            name: 'admin_users',
            component: Users,
            meta: {
                title: 'Users',
                icon: 'person',
                layout: 'main',
                showInNav: true,
                admin: true,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.BINDEZ_ADMIN
                ]
            }
        },
        {
            path: '/admin/dashboard-manager',
            name: 'admin_dashboard-manager',
            component: DashboardManager,
            meta: {
                title: 'Dashboard Manager',
                icon: 'dashboard',
                layout: 'main',
                showInNav: true,
                admin: true,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.BINDEZ_ADMIN
                ]
            }
        },
        {
            path: '/dashboard-manager',
            name: 'dashboard-manager',
            component: DashboardManager,
            meta: {
                title: 'Dashboard Manager',
                icon: 'dashboard',
                layout: 'main',
                showInNav: true,
                organizationAdmin: true,
                roles: [
                    ROLES.ORGANIZATION_ADMIN
                ]
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: 'Login',
                icon: 'vpn_key',
                public: true,
                onlyWhenLoggedOut: true,
                layout: 'empty'
            }
        },
        {
            path: '/journals/:id',
            name: 'journal-details',
            component: JournalDetails,
            meta: {
                title: 'Journal Details',
                layout: 'main',
                admin: false,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.ORGANIZATION_ADMIN,
                    ROLES.ORGANIZATION_USER,
                    ROLES.SCANNING_ADMIN,
                    ROLES.BINDEZ_ADMIN
                ]
            }
        },
        {
            path: '/pages/:id/clipping',
            name: 'clipping',
            component: Clipping,
            meta: {
                title: 'Clipping',
                layout: 'main',
                admin: false,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.ORGANIZATION_ADMIN,
                    ROLES.ORGANIZATION_USER,
                    ROLES.BINDEZ_ADMIN,
                ]
            },
        },
        {
            path: '/reports',
            name: 'reports',
            component: Reports,
            meta: {
                title: 'Reports',
                icon: 'assignment',
                layout: 'main',
                showInNav: true,
                admin: false,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.ORGANIZATION_ADMIN,
                    ROLES.ORGANIZATION_USER,
                    ROLES.BINDEZ_ADMIN,
                ],
            }
        },
        {
            path: '/reports/:id/clips',
            name: 'clips',
            component: Clips,
            meta: {
                title: "Clippings",
                layout: "main",
                admin: false,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.ORGANIZATION_ADMIN,
                    ROLES.ORGANIZATION_USER,
                    ROLES.BINDEZ_ADMIN,
                ],
            }
        },
        {
            path: '/dashboards/:id',
            name: 'dashboard',
            component: Search,
            meta: {
                title: 'Dashboard',
                layout: 'main',
                admin: false,
                showDatePicker: true,
                roles: [
                    ROLES.SUPERADMIN,
                    ROLES.ORGANIZATION_ADMIN,
                    ROLES.ORGANIZATION_USER,
                    ROLES.BINDEZ_ADMIN
                ]
            }
        },
    ]
})

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public)
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
    const loggedIn = !!TokenService.getToken();

    if (!isPublic && !loggedIn) {
        return next({
            path: '/login',
            query: { redirect: to.fullPath }
        });
    }

    if (loggedIn && onlyWhenLoggedOut) {
        return next('/')
    }

    if (loggedIn) {
        const currentUser = UserService.getCurrentUser();
        const currentUserRole = currentUser ? currentUser.roles[0].code : "";
        const isAccessible = to.matched.some(record => !!record.meta.roles.find(role => role === currentUserRole));
    
        if (!isAccessible) return next('/');
    }

    next();
});

export default router
